import { render, staticRenderFns } from "./EstabelecimentosTable.vue?vue&type=template&id=4b96776b&scoped=true&"
import script from "./EstabelecimentosTable.vue?vue&type=script&lang=js&"
export * from "./EstabelecimentosTable.vue?vue&type=script&lang=js&"
import style0 from "./EstabelecimentosTable.vue?vue&type=style&index=0&id=4b96776b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b96776b",
  null
  
)

export default component.exports